import styled from 'styled-components';

export const CopyInput = styled.div`
  display: flex;
`;
